import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class AuditMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.audit.auditMapperError"));

        Object.setPrototypeOf(this, AuditMapperError.prototype);
    }
}